import './App.css'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from './pages/Login';

// {Pages which are not add}
// import Serahan from './pages/QrPenyewa/Serahan';
// import DataProfil from './pages/QrPenyewa/DataProfil';
// import RentArrearsAccount from './pages/RentArrearsAccount';
// import Laporan from './pages/Laporan';
// import KpiSyarikat from './pages/KpiSyarikat';
// import UnitRampasan from './pages/UnitRampasan';
// import UploaderPage from './pages/UploaderPage';
import CheckAuth from './Auths/CheckUser.js';

import AppRouter from './Routes/AppRouter.js';

function App() {


   const token = localStorage.getItem('admin-mobile-token')



  if (!token) {
    return (
      
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
        </Routes>
      </BrowserRouter>
    )

  } else {
  return (
    <BrowserRouter>
    <CheckAuth>
       
       

        <AppRouter/>
       
       
      </CheckAuth>
    </BrowserRouter>
  );
}
}

export default App;
